import { useState, useContext } from "react";
// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
import { useSaveOrder } from "../../state/draftOrderSaveState";
import { useProtectedContent } from "../../hooks/useProtectedContent";
// State
import { useAddressList } from "../../state/addressListState";
// Components
import { EditAddressDialog } from "../../components/EditAddressDialog";
// MUI
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
// import Stack from "@mui/material/Stack";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import { ListItemText } from "@mui/material";
import ListItemIcon from "@mui/material/ListItemIcon";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import BusinessIcon from "@mui/icons-material/Business";
import HomeIcon from "@mui/icons-material/Home";
// import EditIcon from "@mui/icons-material/Edit";

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

export const DeliveryAddressBook = ({ order, setTab }) => {
  const [addressList, setAddressList] = useState([]);
  const [addressListType, setAddressListType] = useState("");
  const [selectedAddress, setSelectedAddress] = useState({});
  const { setAlertNotification } = useContext(AlertNotificationContext);
  const [currentSearchValue, setCurrentSearchValue] = useState("");
  const [filteredAddressList, setFilteredAddressList] = useState([]);

  // Fetch Address List
  const { isError, error, data, isSuccess } = useAddressList(addressListType);

  // Success Function
  const successFunc = () => {
    setAddressList(data.data.data.data.data.savedAddresses);
    setFilteredAddressList(data.data.data.data.data.savedAddresses);
  };

  // Error Function
  const errorFunc = () =>
    setAlertNotification({
      message: `Error: ${data.data.status}: ${data.data.statusText}`,
      severity: "error",
    });

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  //  Do this when a user clicks an address
  const handleAddressClick = (address) => {
    setSelectedAddress(address);
  };

  // Save the order
  const {
    mutate: saveOrder,
    isSuccess: saveSuccess,
    data: saveData,
  } = useSaveOrder();

  // Handle
  const handleSaveOrder = (address) => {
    // Merge the new address object with the existing order object
    let merged = { ...order.data.order, ...address };

    // Remove non-required fields
    delete merged.name2;
    delete merged.showOnPortal;
    delete merged.branchNo;
    saveOrder({
      data: {
        filter: order.data.filter,
        order: merged,
        staff: order.data.staff,
      },
    });
  };

  // Do this on save order success
  const saveSuccessFunc = () => {
    setAlertNotification({
      message: `Address updated`,
      severity: "info",
    });
    setTab(0);
  };

  // Do this on save order error
  const saveErrorFunc = () =>
    setAlertNotification({
      message: `Error: ${saveData.data.status}: ${saveData.data.statusText}`,
      severity: "error",
    });

  // Hook to check the BC API for errors
  useCheckAPI(
    saveSuccess,
    saveData,
    saveData?.data?.status,
    saveSuccessFunc,
    saveErrorFunc,
  );

  //   Save Order
  const handleSaveClick = () => {
    handleSaveOrder(selectedAddress);
  };

  //   Cancel
  const handleCancelClick = () => {
    setTab(0);
  };

  //   New Address
  const handleNewAddressClick = () => {
    setTab(2);
  };

  //   Edit address
  const handleEdit = (addressCode) => {};

  // Filter the address list based on search value
  function filterByValue(array, string) {
    return array.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(string.toLowerCase()),
      ),
    );
  }

  const handleSearchChange = (newValue) => {
    setCurrentSearchValue(newValue.target.value);
  };

  const handleSearchSumbit = (e) => {
    e.preventDefault();
    setFilteredAddressList(filterByValue(addressList, currentSearchValue));
  };

  const handleSearchClear = () => {
    setCurrentSearchValue("");
    setFilteredAddressList(addressList);
  };

  const handleAddressListTypeChange = (event, newType) => {
    if (newType === null) return;
    handleSearchClear();
    setAddressListType(newType);
  };

  return (
    <Paper
      sx={{
        width: "100%",
        // p: 2,
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          p: 2,
        }}
      >
        <Grid size={12}>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6">Address Book</Typography>
            {/* <ComponentAuthorisation allowedRoles={["addressCreate"]}> */}
            <Button
              variant="outlined"
              onClick={handleNewAddressClick}
              disabled={!useProtectedContent("addressCreate")}
            >
              New Address
            </Button>
            {/* </ComponentAuthorisation> */}
          </Stack>
        </Grid>
        <Grid size={12}>
          <Divider />
        </Grid>
        <Grid
          component="form"
          onSubmit={handleSearchSumbit}
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <TextField
            onChange={handleSearchChange}
            value={currentSearchValue}
            label="Search.."
            id="address-search"
            name="Search"
            variant="outlined"
            size="small"
            fullWidth
            slotProps={{
              input: {
                endAdornment: (
                  <>
                    <InputAdornment
                      position="end"
                      sx={{
                        visibility: currentSearchValue ? "visible" : "hidden",
                      }}
                    >
                      <IconButton onClick={handleSearchClear} color="error">
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                    <InputAdornment position="end">
                      <IconButton type="submit">
                        <SearchIcon />
                      </IconButton>
                    </InputAdornment>
                  </>
                ),
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <ToggleButtonGroup
            color="primary"
            size="small"
            value={addressListType}
            exclusive
            onChange={handleAddressListTypeChange}
            aria-label="Address List Type"
          >
            <ToggleButton value="">My Addresses</ToggleButton>

            <ToggleButton
              value="branch"
              disabled={!useProtectedContent("addressListBranch")}
            >
              Branch Addresses
            </ToggleButton>

            <ToggleButton
              value="all"
              disabled={!useProtectedContent("addressListCompany")}
            >
              All Addresses
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
        <Grid size={12}>
          {filteredAddressList?.length ? (
            <List
              sx={{
                width: "100%",
                // maxWidth: 360,
                // bgcolor: 'background.paper',
                position: "relative",
                overflow: "auto",
                maxHeight: 400,
                "& ul": { padding: 0 },
              }}
            >
              {filteredAddressList.map((address) => {
                const addressString = `${
                  address.contact ? address.contact + ", " : ""
                } ${address.name}, ${address.address}, ${
                  address.address2 ? address.address2 + ", " : ""
                }${address.city}${
                  address.county ? ", " + address.county : ""
                }, ${address.country}`;
                return (
                  <ListItem
                    key={address.code}
                    disablePadding
                    selected={selectedAddress.code === address.code}
                    secondaryAction={<EditAddressDialog address={address} />}
                  >
                    <ListItemButton
                      onClick={() => handleAddressClick(address)}
                    >
                      <ListItemIcon>
                        {address.homeaddress === "No" ? (
                          <BusinessIcon />
                        ) : (
                          <HomeIcon />
                        )}
                      </ListItemIcon>
                      <ListItemText
                        // primary={`${address.name}, ${address.address}, ${address.address2}, ${address.city}`}
                        primary={addressString}
                        secondary={address.postCode}
                      />
                    </ListItemButton>
                  </ListItem>
                );
              })}
            </List>
          ) : (
            <Typography
              color="text.secondary"
              sx={{ textAlign: "center", py: 4 }}
            >
              No saved addresses found
            </Typography>
          )}
        </Grid>
        <Grid size={12}>
          <Stack
            direction="row-reverse"
            spacing={2}
            sx={{
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              disabled={
                Object.keys(selectedAddress).length === 0 ? true : false
              }
              onClick={handleSaveClick}
            >
              Save
            </Button>
            <Button variant="outlined" onClick={handleCancelClick}>
              Cancel
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};
